var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("system", { attrs: { leftList: _vm.leftList } }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pageBox" },
        [
          _c(
            "div",
            { staticClass: "breadcrumb" },
            [
              _c(
                "el-breadcrumb",
                { attrs: { separator: "/" } },
                [
                  _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                    _vm._v("首页"),
                  ]),
                  _vm._v(" "),
                  _c("el-breadcrumb-item", [_vm._v("保安详情")]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "pageTab" }, [
            _c(
              "div",
              {
                staticStyle: { "text-align": "right", "margin-bottom": "10px" },
              },
              [
                _vm.pageStatus == 0
                  ? _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.edit()
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    )
                  : _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                _vm.pageStatus = 0
                              },
                            },
                          },
                          [_vm._v("取消")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.edit()
                              },
                            },
                          },
                          [_vm._v("保存")]
                        ),
                      ],
                      1
                    ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "solidBox" }, [
              _c("div", { staticClass: "modelTitle" }, [
                _c(
                  "div",
                  { staticStyle: { display: "flex", "align-items": "center" } },
                  [
                    _c("img", {
                      staticStyle: {
                        width: "30px",
                        height: "30px",
                        "margin-right": "10px",
                      },
                      attrs: {
                        src:
                          _vm.detail.headimgUrl ||
                          require("@/assets/imgs/headImg.png"),
                        alt: "",
                      },
                    }),
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.detail.accountType == 0
                            ? "企业"
                            : _vm.detail.accountType == 1
                            ? "企业员工"
                            : "临勤"
                        ) +
                        "信息\n          "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _vm.detail.accountType == 0 && _vm.pageStatus == 0
                ? _c("div", [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between",
                        },
                      },
                      [
                        _c("div", { staticStyle: { width: "75%" } }, [
                          _c("div", { staticClass: "modelDetail" }, [
                            _c("div", { staticClass: "infoItem" }, [
                              _vm._v(
                                "公司名称：" + _vm._s(_vm.detail.companyName)
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _vm._v("手机号：" + _vm._s(_vm.detail.phone)),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _vm._v(
                                "\n                  统一社会信用代码：" +
                                  _vm._s(_vm.detail.licenseNo) +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _vm._v(
                                "\n                  注册地址：" +
                                  _vm._s(_vm.detail.registerAddress) +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _vm._v(
                                "\n                  注册资金：" +
                                  _vm._s(_vm.detail.registeredCapital) +
                                  "万\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "infoItem" }, [
                              _vm._v(
                                "\n                  经营范围：" +
                                  _vm._s(_vm.detail.businessScope) +
                                  "\n                "
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "modelDetail",
                              staticStyle: {
                                display: "flex",
                                "flex-wrap": "wrap",
                              },
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "infoItem" },
                                [
                                  _vm._v("\n                  监管部门："),
                                  _vm._l(
                                    _vm.detail.sysOrgList,
                                    function (item) {
                                      return _c(
                                        "span",
                                        {
                                          key: item,
                                          staticStyle: {
                                            "margin-right": "10px",
                                          },
                                        },
                                        [_vm._v(_vm._s(item.name))]
                                      )
                                    }
                                  ),
                                ],
                                2
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.detail.businessLicense &&
                        _vm.detail.businessLicense != ""
                          ? _c("el-image", {
                              staticClass: "avatar",
                              attrs: {
                                src: _vm.detail.businessLicense,
                                alt: "",
                                "preview-src-list": [
                                  _vm.detail.businessLicense,
                                ],
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.detail.accountType != 0 && _vm.pageStatus == 0
                ? _c("div", [
                    _c("div", { staticClass: "modelDetail" }, [
                      _c("div", { staticClass: "infoItem" }, [
                        _vm._v(
                          "\n              姓名：" +
                            _vm._s(_vm.detail.cardName || _vm.detail.nickname) +
                            "\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "infoItem" }, [
                        _vm._v("民族：" + _vm._s(_vm.detail.nationality)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "infoItem" }, [
                        _vm._v("手机号：" + _vm._s(_vm.detail.phone)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "infoItem" }, [
                        _vm._v("身份证：" + _vm._s(_vm.detail.cardCode)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "infoItem" }, [
                        _vm._v(
                          "\n              性别：" +
                            _vm._s(
                              _vm.detail.sex == 1
                                ? "男"
                                : _vm.detail.sex == 2
                                ? "女"
                                : ""
                            ) +
                            "\n            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "infoItem" }, [
                        _vm._v("身高：" + _vm._s(_vm.detail.high) + "cm"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "infoItem" }, [
                        _vm._v("体重：" + _vm._s(_vm.detail.weight) + "公斤"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "infoItem" }, [
                        _vm._v("出生日期：" + _vm._s(_vm.detail.birthday)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "infoItem" }, [
                        _vm._v("家庭住址：" + _vm._s(_vm.detail.address)),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "infoItem" },
                      [
                        _vm.detail.cardFrontUrl && _vm.detail.cardFrontUrl != ""
                          ? _c("el-image", {
                              staticClass: "avatar",
                              attrs: {
                                src: _vm.detail.cardFrontUrl,
                                alt: "",
                                "preview-src-list": [_vm.detail.cardFrontUrl],
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.detail.cardBackUrl && _vm.detail.cardBackUrl != ""
                          ? _c("el-image", {
                              staticClass: "avatar",
                              staticStyle: { margin: "0 20px" },
                              attrs: {
                                src: _vm.detail.cardBackUrl,
                                alt: "",
                                "preview-src-list": [_vm.detail.cardBackUrl],
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.detail.guardLicenseUrl &&
                        _vm.detail.guardLicenseUrl != ""
                          ? _c("el-image", {
                              staticClass: "avatar",
                              attrs: {
                                src: _vm.detail.guardLicenseUrl,
                                alt: "",
                                "preview-src-list": [
                                  _vm.detail.guardLicenseUrl,
                                ],
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _vm.detail.accountType == 0 && _vm.pageStatus == 0
              ? _c("div", { staticClass: "solidBox" }, [
                  _c("div", { staticClass: "modelTitle" }, [
                    _vm._v("保安服务许可证信息"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "modelDetail",
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-wrap": "wrap",
                            width: "75%",
                          },
                        },
                        [
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              许可证编号：" +
                                _vm._s(_vm.detail.serviceLicenseNumber) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v("服务范围：" + _vm._s(_vm.detail.gscScope)),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.detail.guardLicenseUrl &&
                      _vm.detail.guardLicenseUrl != ""
                        ? _c("el-image", {
                            staticClass: "avatar",
                            attrs: {
                              src: _vm.detail.guardLicenseUrl,
                              alt: "",
                              "preview-src-list": [_vm.detail.guardLicenseUrl],
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.detail.accountType == 0 && _vm.pageStatus == 0
              ? _c("div", { staticClass: "solidBox" }, [
                  _c("div", { staticClass: "modelTitle" }, [
                    _vm._v("法人信息"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "modelDetail",
                      staticStyle: {
                        display: "flex",
                        "justify-content": "space-between",
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "flex-wrap": "wrap",
                            width: "65%",
                          },
                        },
                        [
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              姓名：" +
                                _vm._s(_vm.detail.legalPersonResp.name) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              民族：" +
                                _vm._s(_vm.detail.legalPersonResp.nationality) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              性别：" +
                                _vm._s(
                                  _vm.detail.legalPersonResp.sex == 1
                                    ? "男"
                                    : "女"
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              出生年月：" +
                                _vm._s(_vm.detail.legalPersonResp.birthday) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              证件有效期：" +
                                _vm._s(
                                  _vm.detail.legalPersonResp.cardValidityStart
                                ) +
                                "-" +
                                _vm._s(
                                  _vm.detail.legalPersonResp.cardValidityEnd
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              签发机关：" +
                                _vm._s(
                                  _vm.detail.legalPersonResp.issuingAuthority
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              地址：" +
                                _vm._s(
                                  _vm.detail.legalPersonResp.currentAddress
                                ) +
                                "\n            "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("el-image", {
                            staticStyle: { width: "150px", height: "100px" },
                            attrs: {
                              src: _vm.detail.legalPersonResp.cardPhotoFront,
                              alt: "",
                              "preview-src-list": [
                                _vm.detail.legalPersonResp.cardPhotoFront,
                              ],
                            },
                          }),
                          _vm._v(" "),
                          _c("el-image", {
                            staticStyle: { width: "150px", height: "100px" },
                            attrs: {
                              src: _vm.detail.legalPersonResp.cardPhotoBack,
                              alt: "",
                              "preview-src-list": [
                                _vm.detail.legalPersonResp.cardPhotoBack,
                              ],
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.pageStatus == 1
              ? _c(
                  "div",
                  { staticStyle: { "margin-top": "20px" } },
                  [
                    _c(
                      "el-form",
                      {
                        ref: "ruleForm",
                        staticClass: "demo-ruleForm",
                        attrs: {
                          model: _vm.ruleForm,
                          rules: _vm.rules,
                          "label-width": "120px",
                        },
                      },
                      [
                        _vm.detail.accountType == 0
                          ? _c(
                              "div",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "统一社会信用代码",
                                      prop: "num",
                                      "label-width": "150",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      model: {
                                        value: _vm.ruleForm.num,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.ruleForm, "num", $$v)
                                        },
                                        expression: "ruleForm.num",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "注册地址",
                                      prop: "address",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      model: {
                                        value: _vm.ruleForm.address,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.ruleForm, "address", $$v)
                                        },
                                        expression: "ruleForm.address",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "法人姓名", prop: "name" },
                                  },
                                  [
                                    _c("el-input", {
                                      model: {
                                        value: _vm.ruleForm.name,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.ruleForm, "name", $$v)
                                        },
                                        expression: "ruleForm.name",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "营业执照照片",
                                      prop: "img",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { position: "relative" } },
                                      [
                                        _c(
                                          "el-upload",
                                          {
                                            staticClass: "avatar-uploader",
                                            attrs: {
                                              action: _vm.uploadUrl,
                                              headers: _vm.deader,
                                              "show-file-list": false,
                                              "on-success":
                                                _vm.handleAvatarSuccess,
                                            },
                                          },
                                          [
                                            _vm.ruleForm.img
                                              ? _c("img", {
                                                  staticClass: "avatar",
                                                  staticStyle: {
                                                    width: "100px",
                                                  },
                                                  attrs: {
                                                    src: _vm.ruleForm.img,
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.ruleForm.img
                                              ? _c(
                                                  "div",
                                                  { staticClass: "modelView1" },
                                                  [_vm._v("编辑")]
                                                )
                                              : _c("i", {
                                                  staticClass:
                                                    "el-icon-plus avatar-uploader-icon",
                                                }),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "保安服务许可证",
                                      prop: "img3",
                                      "label-width": "150",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { position: "relative" } },
                                      [
                                        _c(
                                          "el-upload",
                                          {
                                            staticClass: "avatar-uploader",
                                            attrs: {
                                              action: _vm.uploadUrl,
                                              headers: _vm.deader,
                                              "show-file-list": false,
                                              "on-success":
                                                _vm.handleAvatarSuccess3,
                                            },
                                          },
                                          [
                                            _vm.ruleForm.img3
                                              ? _c("img", {
                                                  staticClass: "avatar",
                                                  staticStyle: {
                                                    width: "100px",
                                                  },
                                                  attrs: {
                                                    src: _vm.ruleForm.img3,
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.ruleForm.img3
                                              ? _c(
                                                  "div",
                                                  { staticClass: "modelView1" },
                                                  [_vm._v("编辑")]
                                                )
                                              : _c("i", {
                                                  staticClass:
                                                    "el-icon-plus avatar-uploader-icon",
                                                }),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.detail.accountType == 2 ||
                        _vm.detail.accountType == 1
                          ? _c(
                              "div",
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "姓名", prop: "cardName" },
                                  },
                                  [
                                    _c("el-input", {
                                      model: {
                                        value: _vm.ruleForm.cardName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "cardName",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.cardName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "身份证号码",
                                      prop: "idNum",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      model: {
                                        value: _vm.ruleForm.idNum,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.ruleForm, "idNum", $$v)
                                        },
                                        expression: "ruleForm.idNum",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "性别", prop: "sex" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "请选择" },
                                        model: {
                                          value: _vm.ruleForm.sex,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.ruleForm, "sex", $$v)
                                          },
                                          expression: "ruleForm.sex",
                                        },
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "未知", value: "0" },
                                        }),
                                        _vm._v(" "),
                                        _c("el-option", {
                                          attrs: { label: "男", value: "1" },
                                        }),
                                        _vm._v(" "),
                                        _c("el-option", {
                                          attrs: { label: "女", value: "2" },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "出生年月", prop: "year" },
                                  },
                                  [
                                    _c("el-date-picker", {
                                      attrs: {
                                        type: "date",
                                        placeholder: "选择日期",
                                        format: "yyyy 年 MM 月 dd 日",
                                        "value-format": "yyyy-MM-dd",
                                      },
                                      model: {
                                        value: _vm.ruleForm.year,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.ruleForm, "year", $$v)
                                        },
                                        expression: "ruleForm.year",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "家庭住址",
                                      prop: "address1",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      model: {
                                        value: _vm.ruleForm.address1,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "address1",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.address1",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "身高", prop: "high" } },
                                  [
                                    _c("el-input", {
                                      attrs: { type: "number" },
                                      model: {
                                        value: _vm.ruleForm.high,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.ruleForm, "high", $$v)
                                        },
                                        expression: "ruleForm.high",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "体重", prop: "weight" } },
                                  [
                                    _c("el-input", {
                                      attrs: { type: "number" },
                                      model: {
                                        value: _vm.ruleForm.weight,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.ruleForm, "weight", $$v)
                                        },
                                        expression: "ruleForm.weight",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "保安证书编号",
                                      prop: "certNumber1",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      model: {
                                        value: _vm.ruleForm.certNumber1,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "certNumber1",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.certNumber1",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "身份证照片（正面）",
                                      prop: "img1",
                                      "label-width": "150",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { position: "relative" } },
                                      [
                                        _c(
                                          "el-upload",
                                          {
                                            staticClass: "avatar-uploader",
                                            staticStyle: {
                                              width: "200px",
                                              height: "200px",
                                            },
                                            attrs: {
                                              action: _vm.uploadUrl,
                                              headers: _vm.deader,
                                              "show-file-list": false,
                                              "on-success":
                                                _vm.handleAvatarSuccess1,
                                            },
                                          },
                                          [
                                            _vm.ruleForm.img1
                                              ? _c("img", {
                                                  staticClass: "avatar",
                                                  staticStyle: {
                                                    width: "200px",
                                                    height: "200px",
                                                  },
                                                  attrs: {
                                                    src: _vm.ruleForm.img1,
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.ruleForm.img1
                                              ? _c(
                                                  "div",
                                                  { staticClass: "modelView" },
                                                  [_vm._v("编辑")]
                                                )
                                              : _c("i", {
                                                  staticClass:
                                                    "el-icon-plus avatar-uploader-icon",
                                                }),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "身份证照片（反面）",
                                      prop: "img2",
                                      "label-width": "170",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { position: "relative" } },
                                      [
                                        _c(
                                          "el-upload",
                                          {
                                            staticClass: "avatar-uploader",
                                            staticStyle: {
                                              width: "200px",
                                              height: "200px",
                                            },
                                            attrs: {
                                              action: _vm.uploadUrl,
                                              headers: _vm.deader,
                                              "show-file-list": false,
                                              "on-success":
                                                _vm.handleAvatarSuccess2,
                                            },
                                          },
                                          [
                                            _vm.ruleForm.img2
                                              ? _c("img", {
                                                  staticClass: "avatar",
                                                  staticStyle: {
                                                    width: "200px",
                                                    height: "200px",
                                                  },
                                                  attrs: {
                                                    src: _vm.ruleForm.img2,
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.ruleForm.img2
                                              ? _c(
                                                  "div",
                                                  { staticClass: "modelView" },
                                                  [_vm._v("编辑")]
                                                )
                                              : _c("i", {
                                                  staticClass:
                                                    "el-icon-plus avatar-uploader-icon",
                                                }),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "保安证照片", prop: "img" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticStyle: { position: "relative" } },
                                      [
                                        _c(
                                          "el-upload",
                                          {
                                            staticClass: "avatar-uploader",
                                            staticStyle: {
                                              width: "200px",
                                              height: "200px",
                                            },
                                            attrs: {
                                              action: _vm.uploadUrl,
                                              headers: _vm.deader,
                                              "show-file-list": false,
                                              "on-success":
                                                _vm.handleAvatarSuccess9,
                                            },
                                          },
                                          [
                                            _vm.ruleForm.certFrontUrl != ""
                                              ? _c("img", {
                                                  staticClass: "avatar",
                                                  staticStyle: {
                                                    width: "200px",
                                                    height: "200px",
                                                  },
                                                  attrs: {
                                                    src: _vm.ruleForm
                                                      .certFrontUrl,
                                                  },
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.ruleForm.certFrontUrl
                                              ? _c(
                                                  "div",
                                                  { staticClass: "modelView" },
                                                  [
                                                    _vm._v(
                                                      "\n                    编辑\n                  "
                                                    ),
                                                  ]
                                                )
                                              : _c("i", {
                                                  staticClass:
                                                    "el-icon-plus avatar-uploader-icon",
                                                }),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "modelTitle",
                staticStyle: { "margin-top": "30px" },
              },
              [_vm._v("账号信息")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "modelDetail" }, [
              _c("div", { staticClass: "infoItem" }, [
                _vm._v("保安证号码：" + _vm._s(_vm.detail.bodyguardCardCode)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "infoItem" }, [
                _vm._v(
                  "\n          保安证编号：" +
                    _vm._s(
                      _vm.detail.bodyguardCerts && _vm.detail.bodyguardCerts[0]
                        ? _vm.detail.bodyguardCerts[0].certNumber
                        : ""
                    ) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "infoItem" }, [
                _vm._v("创建时间：" + _vm._s(_vm.detail.gmtCreate)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "infoItem" }, [
                _vm._v("支付宝账号：" + _vm._s(_vm.detail.alipayCode)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "infoItem" }, [
                _vm._v("充值金额：￥" + _vm._s(_vm.detail.rechargeAmount)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "infoItem" }, [
                _vm._v("余额：￥" + _vm._s(_vm.detail.balanceAmount)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "infoItem" }, [
                _vm._v("违约次数：" + _vm._s(_vm.detail.failedJobs)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "infoItem" }, [
                _vm._v("任务次数：" + _vm._s(_vm.detail.jobsTotal)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "infoItem" }, [
                _vm._v("预期收益：" + _vm._s(_vm.detail.frozenAmount)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "infoItem" }, [
                _vm._v("平台奖励金额：" + _vm._s(_vm.detail.redPacketAmount)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "infoItem" }, [
                _vm._v("任务金额：" + _vm._s(_vm.detail.taskAmount)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "infoItem" }, [
                _vm._v(
                  "\n          手机品牌：" +
                    _vm._s(
                      _vm.detail.lastPhoneBrand
                        ? _vm.detail.lastPhoneBrand
                        : "null"
                    ) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "infoItem" }, [
                _vm._v(
                  "\n          手机型号：" +
                    _vm._s(
                      _vm.detail.lastPhoneModel
                        ? _vm.detail.lastPhoneModel
                        : "null"
                    ) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "infoItem" }, [
                _vm._v(
                  "\n          手机系统号：" +
                    _vm._s(
                      _vm.detail.lastPhoneSystemVersion
                        ? _vm.detail.lastPhoneSystemVersion
                        : "null"
                    ) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "infoItem" }, [
                _vm._v(
                  "\n          最近登录地址：" +
                    _vm._s(
                      _vm.detail.lastLoginAddress
                        ? _vm.detail.lastLoginAddress
                        : ""
                    ) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "infoItem" }, [
                _vm._v(
                  "\n          最近登录省份：" +
                    _vm._s(
                      _vm.detail.lastLoginProvince
                        ? _vm.detail.lastLoginProvince
                        : ""
                    ) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "infoItem" }, [
                _vm._v(
                  "\n          最近登录城市：" +
                    _vm._s(
                      _vm.detail.lastLoginCity ? _vm.detail.lastLoginCity : ""
                    ) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "infoItem" }, [
                _vm._v(
                  "\n          最近登录地区：" +
                    _vm._s(
                      _vm.detail.lastLoginArea ? _vm.detail.lastLoginArea : ""
                    ) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "infoItem" }, [
                _vm._v(
                  "\n          最近登录时间：" +
                    _vm._s(
                      _vm.detail.lastLoginTime ? _vm.detail.lastLoginTime : ""
                    ) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "infoItem" }, [
                _vm._v(
                  "\n          当前App版本号：" +
                    _vm._s(
                      _vm.detail.versionNo ? _vm.detail.versionNo : "null"
                    ) +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "infoItem" }, [
                _vm._v("\n          邀请人：" + _vm._s(_vm.detail.inviteName)),
                _vm.detail.invitePhone && _vm.detail.invitePhone != ""
                  ? _c("span", [
                      _vm._v("(" + _vm._s(_vm.detail.invitePhone) + ")"),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _vm.detail.bodyguardCerts && _vm.detail.bodyguardCerts.length > 0
              ? _c(
                  "div",
                  {
                    staticClass: "modelTitle",
                    staticStyle: { "margin-top": "30px" },
                  },
                  [_vm._v("\n        证件信息\n      ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.detail.bodyguardCerts && _vm.detail.bodyguardCerts.length > 0
              ? _c(
                  "div",
                  {
                    staticClass: "modelDetail",
                    staticStyle: { "margin-top": "20px" },
                  },
                  _vm._l(_vm.detail.bodyguardCerts, function (item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "item",
                        staticStyle: {
                          "text-align": "left",
                          color: "#000",
                          "margin-bottom": "10px",
                        },
                      },
                      [
                        item.certFrontUrl
                          ? _c("el-image", {
                              staticClass: "avatar",
                              attrs: {
                                src: item.certFrontUrl,
                                alt: "",
                                "preview-src-list": [item.certFrontUrl],
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        item.certOppositeUrl
                          ? _c("el-image", {
                              staticClass: "avatar",
                              attrs: {
                                src: item.certOppositeUrl,
                                alt: "",
                                "preview-src-list": [item.certOppositeUrl],
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v("证件名称：" + _vm._s(item.certNumber)),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n            审核状态：" +
                              _vm._s(
                                item.verifyStatus == 0
                                  ? "未通过"
                                  : item.verifyStatus == 1
                                  ? "通过"
                                  : "待审核"
                              ) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", [
                          _vm._v(
                            "\n            证件类型/证件等级：" +
                              _vm._s(item.careerTypeName) +
                              "/" +
                              _vm._s(item.levelTypeName) +
                              "\n          "
                          ),
                        ]),
                      ],
                      1
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.detail.accountType != 0 &&
            _vm.detail.xwbankStatus == 1 &&
            _vm.detail.memberBanksVO
              ? _c(
                  "div",
                  {
                    staticClass: "solidBox",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c("div", { staticClass: "modelTitle" }, [
                      _vm._v("个人开户信息"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "modelDetail",
                        staticStyle: { display: "flex" },
                      },
                      [
                        _c("div", [
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v("姓名：" + _vm._s(_vm.detail.cardName)),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v("地址：" + _vm._s(_vm.detail.address)),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v("身份证号：" + _vm._s(_vm.detail.cardCode)),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              银行卡号：" +
                                _vm._s(_vm.detail.memberBanksVO.bankAccountNo) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              开户行名称：" +
                                _vm._s(_vm.detail.memberBanksVO.bankFullName) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v("手机号码：" + _vm._s(_vm.detail.phone)),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              职业：" +
                                _vm._s(_vm.detail.individualVocationName) +
                                "\n            "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticStyle: { "margin-left": "50px" } },
                          [
                            _c(
                              "div",
                              { staticStyle: { "margin-bottom": "20px" } },
                              [_vm._v("身份证照片")]
                            ),
                            _vm._v(" "),
                            _c("el-image", {
                              staticStyle: { width: "150px", height: "100px" },
                              attrs: {
                                src: _vm.detail.cardFrontUrl,
                                alt: "",
                                "preview-src-list": [_vm.detail.cardFrontUrl],
                              },
                            }),
                            _vm._v(" "),
                            _c("el-image", {
                              staticStyle: { width: "150px", height: "100px" },
                              attrs: {
                                src: _vm.detail.cardBackUrl,
                                alt: "",
                                "preview-src-list": [_vm.detail.cardBackUrl],
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.detail.accountType == 0 &&
            _vm.detail.xwbankStatus == 1 &&
            _vm.detail.companyInfo
              ? _c(
                  "div",
                  {
                    staticClass: "solidBox",
                    staticStyle: { "margin-top": "20px" },
                  },
                  [
                    _c("div", { staticClass: "modelTitle" }, [
                      _vm._v("企业开户信息"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "modelDetail",
                        staticStyle: {
                          display: "flex",
                          "justify-content": "space-between",
                        },
                      },
                      [
                        _c("div", { staticStyle: { width: "30%" } }, [
                          _c(
                            "div",
                            [
                              _c("div", { staticStyle: { margin: "20px 0" } }, [
                                _vm._v("营业执照照片"),
                              ]),
                              _vm._v(" "),
                              _c("el-image", {
                                staticStyle: {
                                  width: "150px",
                                  height: "100px",
                                },
                                attrs: {
                                  src: _vm.detail.companyInfo.businessLicense,
                                  alt: "",
                                  "preview-src-list": [
                                    _vm.detail.companyInfo.businessLicense,
                                  ],
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              企业全称：" +
                                _vm._s(_vm.detail.companyInfo.companyName) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              经营证件类型：" +
                                _vm._s(
                                  _vm.detail.companyInfo.enterpriseLicenseName
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              营业执照号码：" +
                                _vm._s(_vm.detail.companyInfo.licenseNo) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              行业代码：" +
                                _vm._s(_vm.detail.companyInfo.enterpriseTrade) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              企业实际经营地址：" +
                                _vm._s(
                                  _vm.detail.companyInfo.enterpriseRealAddress
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              企业对公户开户行名称：" +
                                _vm._s(_vm.detail.companyInfo.bankName) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              企业对公户开户行号：" +
                                _vm._s(_vm.detail.companyInfo.bankAccountNo) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              企业对公账户号：" +
                                _vm._s(
                                  _vm.detail.companyInfo.enterpriseBankCardNo
                                ) +
                                "\n            "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticStyle: { width: "30%" } }, [
                          _c(
                            "div",
                            [
                              _c("div", { staticStyle: { margin: "20px 0" } }, [
                                _vm._v("法人身份证照片"),
                              ]),
                              _vm._v(" "),
                              _c("el-image", {
                                staticStyle: {
                                  width: "150px",
                                  height: "100px",
                                },
                                attrs: {
                                  src: JSON.parse(
                                    _vm.detail.companyInfo.legalPerson
                                  ).cardPhotoFront,
                                  alt: "",
                                  "preview-src-list": [
                                    JSON.parse(
                                      _vm.detail.companyInfo.legalPerson
                                    ).cardPhotoFront,
                                  ],
                                },
                              }),
                              _vm._v(" "),
                              _c("el-image", {
                                staticStyle: {
                                  width: "150px",
                                  height: "100px",
                                },
                                attrs: {
                                  src: JSON.parse(
                                    _vm.detail.companyInfo.legalPerson
                                  ).cardPhotoBack,
                                  alt: "",
                                  "preview-src-list": [
                                    JSON.parse(
                                      _vm.detail.companyInfo.legalPerson
                                    ).cardPhotoBack,
                                  ],
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              法人姓名：" +
                                _vm._s(
                                  JSON.parse(_vm.detail.companyInfo.legalPerson)
                                    .name
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v("法人证件类型：身份证"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              法人身份证号：" +
                                _vm._s(
                                  JSON.parse(_vm.detail.companyInfo.legalPerson)
                                    .cardNo
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              法人手机号：" +
                                _vm._s(
                                  JSON.parse(_vm.detail.companyInfo.legalPerson)
                                    .contactInformation
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              企业控股股东名称：" +
                                _vm._s(
                                  JSON.parse(
                                    _vm.detail.companyInfo
                                      .enterpriseShareholderInfo
                                  )[0].enterpriseShareholderName
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v("企业控股股东证件类型：身份证"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              企业控股股东证件号码：" +
                                _vm._s(
                                  JSON.parse(
                                    _vm.detail.companyInfo
                                      .enterpriseShareholderInfo
                                  )[0].enterpriseShareholderIdCardNo
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              企业控股股东证件起始日期：" +
                                _vm._s(
                                  JSON.parse(
                                    _vm.detail.companyInfo
                                      .enterpriseShareholderInfo
                                  )[0].enterpriseShareholderIdCardValidStartDate
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              企业控投股东证件截止日期：" +
                                _vm._s(
                                  JSON.parse(
                                    _vm.detail.companyInfo
                                      .enterpriseShareholderInfo
                                  )[0].enterpriseShareholderIdCardValidDate
                                ) +
                                "\n            "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticStyle: { width: "30%" } }, [
                          _c(
                            "div",
                            [
                              _c("div", { staticStyle: { margin: "20px 0" } }, [
                                _vm._v("联系人身份证照片"),
                              ]),
                              _vm._v(" "),
                              _c("el-image", {
                                staticStyle: {
                                  width: "150px",
                                  height: "100px",
                                },
                                attrs: {
                                  src: JSON.parse(
                                    _vm.detail.companyInfo.contactInfo
                                  ).cardPhotoFront,
                                  alt: "",
                                  "preview-src-list": [
                                    JSON.parse(
                                      _vm.detail.companyInfo.contactInfo
                                    ).cardPhotoFront,
                                  ],
                                },
                              }),
                              _vm._v(" "),
                              _c("el-image", {
                                staticStyle: {
                                  width: "150px",
                                  height: "100px",
                                },
                                attrs: {
                                  src: JSON.parse(
                                    _vm.detail.companyInfo.contactInfo
                                  ).cardPhotoBack,
                                  alt: "",
                                  "preview-src-list": [
                                    JSON.parse(
                                      _vm.detail.companyInfo.contactInfo
                                    ).cardPhotoBack,
                                  ],
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              联系人姓名：" +
                                _vm._s(
                                  JSON.parse(_vm.detail.companyInfo.contactInfo)
                                    .name
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v("联系人证件类型：身份证"),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              联系人身份证号：" +
                                _vm._s(
                                  JSON.parse(_vm.detail.companyInfo.contactInfo)
                                    .cardNo
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              联系人手机号：" +
                                _vm._s(
                                  JSON.parse(_vm.detail.companyInfo.contactInfo)
                                    .contactInformation
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              企业最终受益人名称：" +
                                _vm._s(
                                  JSON.parse(
                                    _vm.detail.companyInfo
                                      .enterpriseBeneficiaryInfos
                                  )[0].enterpriseBeneficiaryName
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              企业最终受益人证件类型：" +
                                _vm._s(
                                  JSON.parse(
                                    _vm.detail.companyInfo
                                      .enterpriseBeneficiaryInfos
                                  )[0].enterpriseBeneficiaryIdCardType == "B01"
                                    ? "身份证"
                                    : JSON.parse(
                                        _vm.detail.companyInfo
                                          .enterpriseBeneficiaryInfos
                                      )[0].enterpriseBeneficiaryIdCardType ==
                                      "B04"
                                    ? "护照"
                                    : "营业执照"
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              企业最终受益人证件号码：" +
                                _vm._s(
                                  JSON.parse(
                                    _vm.detail.companyInfo
                                      .enterpriseBeneficiaryInfos
                                  )[0].enterpriseBeneficiaryIdCardNo
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              企业最终受益人联系电话：" +
                                _vm._s(
                                  JSON.parse(
                                    _vm.detail.companyInfo
                                      .enterpriseBeneficiaryInfos
                                  )[0].enterpriseBeneficiaryIdContactPhone
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              企业最终受益人证件起始日期：" +
                                _vm._s(
                                  JSON.parse(
                                    _vm.detail.companyInfo
                                      .enterpriseBeneficiaryInfos
                                  )[0].enterpriseBeneficiaryIdCardValidStartDate
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              企业最终受益人证件截止日期：" +
                                _vm._s(
                                  JSON.parse(
                                    _vm.detail.companyInfo
                                      .enterpriseBeneficiaryInfos
                                  )[0].enterpriseBeneficiaryIdCardValidDate
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              企业最终受益人联系地址：" +
                                _vm._s(
                                  JSON.parse(
                                    _vm.detail.companyInfo
                                      .enterpriseBeneficiaryInfos
                                  )[0].enterpriseBeneficiaryAddress
                                ) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "infoItem" }, [
                            _vm._v(
                              "\n              企业最终受益人受益方式：" +
                                _vm._s(
                                  JSON.parse(
                                    _vm.detail.companyInfo
                                      .enterpriseBeneficiaryInfos
                                  )[0].enterpriseBeneficiaryShareRatio == "A01"
                                    ? "直接或间接控股25%（含）以上"
                                    : JSON.parse(
                                        _vm.detail.companyInfo
                                          .enterpriseBeneficiaryInfos
                                      )[0].enterpriseBeneficiaryShareRatio ==
                                      "A02"
                                    ? "通过人事、财务等其他方式对公司进行控制"
                                    : JSON.parse(
                                        _vm.detail.companyInfo
                                          .enterpriseBeneficiaryInfos
                                      )[0].enterpriseBeneficiaryShareRatio ==
                                      "A03"
                                    ? "高级管理人员"
                                    : JSON.parse(
                                        _vm.detail.companyInfo
                                          .enterpriseBeneficiaryInfos
                                      )[0].enterpriseBeneficiaryShareRatio ==
                                      "A04"
                                    ? "法人或公司负责人"
                                    : "其他"
                                ) +
                                "\n            "
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "modelTitle",
                staticStyle: { "margin-top": "30px" },
              },
              [_vm._v("记录列表")]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-top": "30px" } },
              [
                _c(
                  "el-tabs",
                  {
                    attrs: { type: "border-card" },
                    on: { "tab-click": _vm.handleClick },
                  },
                  [
                    _c(
                      "el-tab-pane",
                      { attrs: { label: "任务记录" } },
                      [
                        _c(
                          "el-table",
                          {
                            ref: "scrollTable",
                            staticStyle: { width: "100%" },
                            attrs: { data: _vm.tableData, border: "" },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "jobNo",
                                label: "任务编号",
                                align: "center",
                                width: "150",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "customName",
                                label: "发布人名",
                                align: "center",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "customPhone",
                                label: "手机号",
                                align: "center",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "inviteAmount",
                                label: "邀请收益",
                                align: "center",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "jobName",
                                label: "任务名称",
                                align: "center",
                                width: "180",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { label: "要求身高", align: "center" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.high == 0
                                              ? "不限"
                                              : scope.row.high
                                          )
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "membersNum",
                                label: "要求人数",
                                align: "center",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { label: "单价", align: "center" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          "￥" + _vm._s(scope.row.unitPrice)
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { label: "总计", align: "center" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v("￥" + _vm._s(scope.row.price)),
                                      ]),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "状态",
                                align: "center",
                                width: "130",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      scope.row.workStatus == 1
                                        ? _c(
                                            "span",
                                            { staticClass: "blueColor" },
                                            [_vm._v("未开始")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.workStatus == 2
                                        ? _c(
                                            "span",
                                            { staticClass: "blueColor" },
                                            [_vm._v("工作中")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.workStatus == 3
                                        ? _c(
                                            "span",
                                            { staticClass: "blueColor" },
                                            [_vm._v("已完成")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.workStatus == 4
                                        ? _c(
                                            "span",
                                            { staticClass: "blueColor" },
                                            [_vm._v("已结算")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.workStatus == 5
                                        ? _c(
                                            "span",
                                            { staticClass: "greenColor" },
                                            [_vm._v("已取消")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.workStatus == 6
                                        ? _c(
                                            "span",
                                            { staticClass: "greenColor" },
                                            [_vm._v("已开除(未结算)")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.workStatus == 7
                                        ? _c(
                                            "span",
                                            { staticClass: "greenColor" },
                                            [_vm._v("已开除(已结算)")]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                label: "创建/完成时间",
                                align: "center",
                                width: "150",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("div", [
                                        _vm._v(_vm._s(scope.row.actionAt)),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(_vm._s(scope.row.jobEnd)),
                                      ]),
                                    ]
                                  },
                                },
                              ]),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-tab-pane",
                      { attrs: { label: "违约记录" } },
                      [
                        _c(
                          "el-table",
                          {
                            ref: "scrollTable",
                            staticStyle: { width: "100%" },
                            attrs: { data: _vm.tableData, border: "" },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "violateLogNo",
                                label: "编号",
                                width: "180",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "jobTitle",
                                label: "任务名称",
                                width: "180",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "violateRuleId",
                                label: "触发规则",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "violateAmount",
                                label: "违约金额",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { prop: "violateAt", label: "违约时间" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-tab-pane",
                      { attrs: { label: "钱包明细" } },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "btn",
                            staticStyle: { "margin-bottom": "10px" },
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.exportList()
                              },
                            },
                          },
                          [_vm._v("导出")]
                        ),
                        _c(
                          "el-table",
                          {
                            ref: "scrollTable",
                            staticStyle: { width: "100%" },
                            attrs: { data: _vm.tableData, border: "" },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "billDetailNo",
                                label: "帐单编号",
                                width: "130",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { label: "保安姓名", width: "130" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.detail.cardName ||
                                              _vm.detail.nickname
                                          )
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "jobNo",
                                label: "任务编号",
                                width: "130",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "jobName",
                                label: "任务名称",
                                width: "130",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { label: "变动类型" },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(scope.row.changeName)),
                                      ]),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "changeAmount",
                                label: "变动金额",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(
                                            scope.row.changeTo == 0 ? "+" : "-"
                                          ) +
                                          _vm._s(
                                            scope.row.changeType == 3
                                              ? scope.row.changeAmount
                                              : scope.row.actualAmount
                                          ) +
                                          "\n                "
                                      ),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { prop: "taxAmount", label: "税费(元)" },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { prop: "channelName", label: "支付方式" },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "thirdPaymentOrder",
                                label: "第三方流水号",
                                width: "130",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "paymentOrder",
                                label: "平台支付单号",
                                width: "130",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "changeAmount",
                                label: "支付状态",
                              },
                              scopedSlots: _vm._u([
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(scope.row.statusName)),
                                      ]),
                                    ]
                                  },
                                },
                              ]),
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "paymentAt",
                                label: "支付时间",
                                width: "130",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "gmtCreate",
                                label: "创建时间",
                                width: "130",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-tab-pane",
                      { attrs: { label: "绑定银行卡" } },
                      [
                        _c(
                          "el-table",
                          {
                            ref: "scrollTable",
                            staticStyle: { width: "100%" },
                            attrs: { data: _vm.tableData, border: "" },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "memberName",
                                label: "姓名",
                                width: "180",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "bankFullName",
                                label: "开户行",
                                width: "180",
                              },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: { prop: "bankName", label: "银行简称" },
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "bankAccountNo",
                                label: "银行卡号",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-pagination", {
                      attrs: {
                        "page-sizes": [10, 20, 30, 50],
                        "page-size": _vm.pageSize,
                        layout: "total, prev, pager, next,sizes",
                        total: _vm.total,
                      },
                      on: {
                        "size-change": _vm.handleSizeChange,
                        "current-change": _vm.handleCurrentChange,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                title: "用户标签",
                visible: _vm.dialogVisible,
                width: "30%",
                "before-close": _vm.handleClose,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "tagList" },
                _vm._l(_vm.tagsList, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      class: ["item", item.isSelect == "1" ? "select" : ""],
                      on: {
                        click: function ($event) {
                          return _vm.selectTag(item)
                        },
                      },
                    },
                    [_vm._v("\n          " + _vm._s(item.name) + "\n        ")]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c("el-button", { on: { click: _vm.handleClose } }, [
                    _vm._v("取 消"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.confrimTag()
                        },
                      },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }